import * as types from './types';

const fetchPostingFiltered = id => ({ type: types.FETCH_POSTING, payload: id });
const fetchPostingFilteredSucceeded = posting => ({ type: types.FETCH_POSTING_SUCCEEDED, payload: posting });
const fetchPostingFilteredFailed = () => ({ type: types.FETCH_POSTING_FAILED });

const setNoPosting = () => ({ type: types.NO_POSTING });

export { fetchPostingFiltered, fetchPostingFilteredSucceeded, fetchPostingFilteredFailed, setNoPosting };
